import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL;
// const API_BASE_URL = 'http://localhost:8070/jmk001/api';
const token = sessionStorage.getItem('token');

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}`, },
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

// Sales Executive APIs
export const salesExecutiveApi = {
  getAll: () => apiClient.get('/sales-executives'),
  getById: (id) => apiClient.get(`/sales-executives/${id}`),
  create: (data) => apiClient.post('/sales-executives', data),
  update: (id, data) => apiClient.put(`/sales-executives/${id}`, data),
  delete: (id) => apiClient.delete(`/sales-executives/${id}`),
};

// Marketing APIs
export const marketingApi = {
  getAll: () => apiClient.get('/marketing'),
  getById: (id) => apiClient.get(`/marketing/${id}`),
  getBySalesExecutive: (id) => apiClient.get(`/marketing/sales-executive/${id}`),
  create: (data) => apiClient.post('/marketing', data),
  update: (id, data) => apiClient.put(`/marketing/${id}`, data),
  delete: (id) => apiClient.delete(`/marketing/${id}`),
};

// Follow-Up APIs
export const followUpApi = {
  getAll: () => apiClient.get('/follow-ups'),
  getById: (id) => apiClient.get(`/follow-ups/${id}`),
  getByMarketing: (id) => apiClient.get(`/follow-ups/marketing/${id}`),
  create: (id,data) => apiClient.post(`/follow-ups/${id}`, data),
  update: (id, data) => apiClient.put(`/follow-ups/${id}`, data),
  delete: (id) => apiClient.delete(`/follow-ups/${id}`),
};

export default apiClient;